import clsx from "clsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FieldValues, FieldPath, PathValue } from "react-hook-form";

import { FieldWrapper } from "./FieldWrapper";
import { FormFieldProps } from "@/types/common";

export const DateField = <
  TFormValues extends FieldValues,
  TFieldName extends FieldPath<TFormValues>
>({
  label,
  error,
  value,
  setValue,
  name,
  className,
}: FormFieldProps<TFormValues, TFieldName>) => {
  return (
    <FieldWrapper label={label} error={error}>
      <DatePicker
        selected={value}
        onChange={(value) =>
          setValue(name, value as PathValue<TFormValues, TFieldName>)
        }
        className={clsx(
          "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm",
          className
        )}
        wrapperClassName="!block"
        shouldCloseOnSelect
      />
    </FieldWrapper>
  );
};
